export default {
    manage_deletedInput: "Input Label was deleted successfully",
    manage_deletedInputs: "Input Labels was deleted successfully",
    manage_deleteManageInput_deleteInput: "Delete Input Label",
    manage_deleteManageInput_deleteInputs: "Delete Input Labels",
    manage_deleteManageInput_confirmationMessage:
    "Are you sure you want to remove the following Input Labels?",
}